import { useEffect } from 'react';
import { storageService } from 'infrastructure/services/StorageService';
/* import { useAuthMe } from 'view/pages/auth/hooks/useAuthMe'; */
/* import { useAuthGoogleMe } from 'view/pages/auth/hooks/useAuthGoogleMe'; */
import { Spinner } from 'view/components';

import { useNavigate } from 'react-router-dom';

const SocialLoginPage = () => {
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');
  const refreshToken = params.get('refreshToken');
  const error = params.get('error');

  useEffect(() => {
    const processTokens = async () => {
      if (error) {
        window.opener?.postMessage(
          {
            type: 'google_auth_error',
            error,
          },
          window.location.origin
        );
        window.close();
        return;
      }

      if (token && refreshToken) {
        try {
          // Отправляем токены в основное окно
          window.opener?.postMessage(
            {
              type: 'google_auth_tokens',
              token,
              refreshToken,
            },
            window.location.origin
          );

          // Можно также сохранить в текущем окне (popup) если нужно
          await storageService.setItem('accessToken', token);
          await storageService.setItem('refreshToken', refreshToken);

          // Закрываем popup после небольшой задержки
          setTimeout(() => {
            return window.close();
          }, 300);
        } catch (e) {
          window.opener?.postMessage(
            {
              type: 'google_auth_error',
              error: 'Failed to process tokens',
            },
            window.location.origin
          );
          window.close();
        }
      }
    };

    processTokens();
  }, [token, refreshToken, error, navigate]);

  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Spinner variant="outlined" />
    </div>
  );
};

export default SocialLoginPage;
